import { render, staticRenderFns } from "./ServiceDashboardListAbstract.vue?vue&type=template&id=531b83d6&"
import script from "./ServiceDashboardListAbstract.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardListAbstract.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardListAbstract.vue?vue&type=style&index=0&id=531b83d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports